// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.servicePage_servicePage__GFO\\+X {
  background: #f5f7fb;
  padding: 50px 0 80px;
}

.servicePage_container__VYOD- {
  width: min(1160px, 100%);
  margin: 0 auto;
  padding: 0 16px;
}

.servicePage_pageTitle__9QFqR {
  font-size: 32px;
  font-weight: 700;
  color: #24346d;
  text-align: center;
  margin-bottom: 28px;
}

/* TOP TABS (screenshotted style) */
.servicePage_tabs__bTvQ0 {
  display: flex;
  gap: 14px;
  flex-wrap: wrap;
  margin-bottom: 28px;
}

.servicePage_tabButton__6iEZp {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 18px;
  border-radius: 12px;
  border: 1px solid #e2e6f2;
  background: #fff;
  font-size: 16px;
  font-weight: 600;
  color: #24346d;
  cursor: pointer;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.06);
  transition: 0.2s ease;
}

.servicePage_activeTab__vUMIb {
  background: #24346d;
  color: #fff;
  border-color: #24346d;
}
.servicePage_activeTab__vUMIb .servicePage_icon__e0BJt {
  filter: brightness(10);
}

.servicePage_icon__e0BJt {
  font-size: 18px;
}

.servicePage_icon__e0BJt {
  width: 32px;
  height: 32px;
  object-fit: contain;
  margin-right: 8px;
  flex-shrink: 0;
}

/* LAYOUT */
.servicePage_layout__wnW1T {
  display: grid;
  grid-template-columns: 1fr 280px;
  gap: 24px;
  align-items: start;
}

/* CONTENT */
.servicePage_content__HYlFo {
  background: #fff;
  border-radius: 16px;
  padding: 22px 22px 10px;
  box-shadow: 0 10px 26px rgba(0, 0, 0, 0.08);
}

.servicePage_section__ya20K {
  scroll-margin-top: 120px;
  padding-bottom: 18px;
  margin-bottom: 18px;
  border-bottom: 1px solid #eef0f6;
}
.servicePage_section__ya20K:last-child {
  border-bottom: none;
}

.servicePage_sectionTitle__af2Eq {
  font-size: 20px;
  font-weight: 700;
  color: #24346d;
  margin-bottom: 10px;
}

.servicePage_paragraph__fitsd {
  font-size: 15px;
  line-height: 1.65;
  color: #1f244b;
  margin-bottom: 10px;
}

.servicePage_list__sz5od {
  padding-left: 18px;
  margin: 8px 0 0;
  font-size: 15px;
  line-height: 1.6;
  color: #1f244b;
}
.servicePage_list__sz5od li + li {
  margin-top: 6px;
}

/* SIDEBAR */
.servicePage_sidebar__9tHJO {
  position: sticky;
  top: 110px;
}

.servicePage_sidebarToggle__LYNfh {
  display: none;
  width: 100%;
  padding: 12px 14px;
  border-radius: 10px;
  border: 1px solid #e2e6f2;
  background: #fff;
  font-weight: 600;
  color: #24346d;
  cursor: pointer;
  margin-bottom: 8px;
}

.servicePage_sidebarInner__U1\\+fy {
  background: #fff;
  border-radius: 14px;
  padding: 10px;
  box-shadow: 0 10px 26px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.servicePage_menuItem__xyK0c {
  text-align: left;
  padding: 10px 12px;
  border-radius: 10px;
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 14px;
  color: #24346d;
  transition: 0.15s ease;
}

.servicePage_menuItemActive__A9QW2 {
  background: #24346d;
  color: #fff;
}

/* responsive */
@media (max-width: 992px) {
  .servicePage_layout__wnW1T {
    grid-template-columns: 1fr 240px;
  }
}
@media (max-width: 768px) {
  .servicePage_pageTitle__9QFqR {
    font-size: 26px;
  }
  .servicePage_layout__wnW1T {
    grid-template-columns: 1fr;
  }
  .servicePage_sidebar__9tHJO {
    position: static;
    order: -1;
    margin-bottom: 12px;
  }
  .servicePage_sidebarToggle__LYNfh {
    display: block;
  }
  .servicePage_sidebarInner__U1\\+fy {
    display: none;
  }
  .servicePage_sidebarOpen__2XNx8 {
    display: flex;
  }
}
@media (max-width: 520px) {
  .servicePage_tabs__bTvQ0 {
    flex-direction: column;
    gap: 10px;
  }
  .servicePage_tabButton__6iEZp {
    width: 100%;
    justify-content: flex-start; /* ⬅️ կարևորը */
    padding: 14px 16px;
    text-align: left;
  }
  /* icon fixed column */
  .servicePage_icon__e0BJt {
    width: 26px;
    height: 26px;
    min-width: 26px; /* ⬅️ բոլոր icon-ները նույն սյունակում */
    margin-right: 12px;
  }
  /* text column */
  .servicePage_tabButton__6iEZp span {
    flex: 1 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/styleService/servicePage.module.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,mBAAA;EACA,oBAAA;AAEF;;AACA;EACE,wBAAA;EACA,cAAA;EACA,eAAA;AAEF;;AACA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;AAEF;;AACA,mCAAA;AACA;EACE,aAAA;EACA,SAAA;EACA,eAAA;EACA,mBAAA;AAEF;;AACA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,0CAAA;EACA,qBAAA;AAEF;;AACA;EACE,mBAAA;EACA,WAAA;EACA,qBAAA;AAEF;AAAE;EACE,sBAAA;AAEJ;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;AACF;;AAGA,WAAA;AACA;EACE,aAAA;EACA,gCAAA;EACA,SAAA;EACA,kBAAA;AAAF;;AAGA,YAAA;AACA;EACE,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,2CAAA;AAAF;;AAGA;EACE,wBAAA;EACA,oBAAA;EACA,mBAAA;EACA,gCAAA;AAAF;AAEE;EACE,mBAAA;AAAJ;;AAIA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AADF;;AAIA;EACE,eAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;AADF;;AAIA;EACE,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AADF;AAGE;EACE,eAAA;AADJ;;AAKA,YAAA;AACA;EACE,gBAAA;EACA,UAAA;AAFF;;AAKA;EACE,aAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AAFF;;AAKA;EACE,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,2CAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAFF;;AAKA;EACE,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;EACA,sBAAA;AAFF;;AAMA;EACE,mBAAA;EACA,WAAA;AAHF;;AAOA,eAAA;AACA;EACE;IACE,gCAAA;EAJF;AACF;AAOA;EACE;IACE,eAAA;EALF;EAQA;IACE,0BAAA;EANF;EASA;IACE,gBAAA;IACA,SAAA;IACA,mBAAA;EAPF;EAUA;IACE,cAAA;EARF;EAWA;IACE,aAAA;EATF;EAYA;IACE,aAAA;EAVF;AACF;AAaA;EAEE;IACE,sBAAA;IACA,SAAA;EAZF;EAeA;IACE,WAAA;IACA,2BAAA,EAAA,eAAA;IACA,kBAAA;IACA,gBAAA;EAbF;EAgBA,sBAAA;EACA;IACE,WAAA;IACA,YAAA;IACA,eAAA,EAAA,wCAAA;IACA,kBAAA;EAdF;EAiBA,gBAAA;EACA;IACE,SAAA;EAfF;AACF","sourcesContent":[".servicePage {\r\n  background: #f5f7fb;\r\n  padding: 50px 0 80px;\r\n}\r\n\r\n.container {\r\n  width: min(1160px, 100%);\r\n  margin: 0 auto;\r\n  padding: 0 16px;\r\n}\r\n\r\n.pageTitle {\r\n  font-size: 32px;\r\n  font-weight: 700;\r\n  color: #24346d;\r\n  text-align: center;\r\n  margin-bottom: 28px;\r\n}\r\n\r\n/* TOP TABS (screenshotted style) */\r\n.tabs {\r\n  display: flex;\r\n  gap: 14px;\r\n  flex-wrap: wrap;\r\n  margin-bottom: 28px;\r\n}\r\n\r\n.tabButton {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  padding: 12px 18px;\r\n  border-radius: 12px;\r\n  border: 1px solid #e2e6f2;\r\n  background: #fff;\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  color: #24346d;\r\n  cursor: pointer;\r\n  box-shadow: 0 6px 16px rgba(0,0,0,0.06);\r\n  transition: 0.2s ease;\r\n}\r\n\r\n.activeTab {\r\n  background: #24346d;\r\n  color: #fff;\r\n  border-color: #24346d;\r\n\r\n  .icon {\r\n    filter: brightness(10);\r\n  }\r\n}\r\n\r\n.icon {\r\n  font-size: 18px;\r\n}\r\n\r\n.icon {\r\n  width: 32px;\r\n  height: 32px;\r\n  object-fit: contain;\r\n  margin-right: 8px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n\r\n/* LAYOUT */\r\n.layout {\r\n  display: grid;\r\n  grid-template-columns: 1fr 280px;\r\n  gap: 24px;\r\n  align-items: start;\r\n}\r\n\r\n/* CONTENT */\r\n.content {\r\n  background: #fff;\r\n  border-radius: 16px;\r\n  padding: 22px 22px 10px;\r\n  box-shadow: 0 10px 26px rgba(0,0,0,0.08);\r\n}\r\n\r\n.section {\r\n  scroll-margin-top: 120px;\r\n  padding-bottom: 18px;\r\n  margin-bottom: 18px;\r\n  border-bottom: 1px solid #eef0f6;\r\n\r\n  &:last-child {\r\n    border-bottom: none;\r\n  }\r\n}\r\n\r\n.sectionTitle {\r\n  font-size: 20px;\r\n  font-weight: 700;\r\n  color: #24346d;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.paragraph {\r\n  font-size: 15px;\r\n  line-height: 1.65;\r\n  color: #1f244b;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.list {\r\n  padding-left: 18px;\r\n  margin: 8px 0 0;\r\n  font-size: 15px;\r\n  line-height: 1.6;\r\n  color: #1f244b;\r\n\r\n  li + li {\r\n    margin-top: 6px;\r\n  }\r\n}\r\n\r\n/* SIDEBAR */\r\n.sidebar {\r\n  position: sticky;\r\n  top: 110px;\r\n}\r\n\r\n.sidebarToggle {\r\n  display: none;\r\n  width: 100%;\r\n  padding: 12px 14px;\r\n  border-radius: 10px;\r\n  border: 1px solid #e2e6f2;\r\n  background: #fff;\r\n  font-weight: 600;\r\n  color: #24346d;\r\n  cursor: pointer;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.sidebarInner {\r\n  background: #fff;\r\n  border-radius: 14px;\r\n  padding: 10px;\r\n  box-shadow: 0 10px 26px rgba(0,0,0,0.08);\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 6px;\r\n}\r\n\r\n.menuItem {\r\n  text-align: left;\r\n  padding: 10px 12px;\r\n  border-radius: 10px;\r\n  border: none;\r\n  background: transparent;\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n  color: #24346d;\r\n  transition: 0.15s ease;\r\n\r\n}\r\n\r\n.menuItemActive {\r\n  background: #24346d;\r\n  color: #fff;\r\n}\r\n\r\n\r\n/* responsive */\r\n@media (max-width: 992px) {\r\n  .layout {\r\n    grid-template-columns: 1fr 240px;\r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .pageTitle {\r\n    font-size: 26px;\r\n  }\r\n\r\n  .layout {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .sidebar {\r\n    position: static;\r\n    order: -1;\r\n    margin-bottom: 12px;\r\n  }\r\n\r\n  .sidebarToggle {\r\n    display: block;\r\n  }\r\n\r\n  .sidebarInner {\r\n    display: none;\r\n  }\r\n\r\n  .sidebarOpen {\r\n    display: flex;\r\n  }\r\n}\r\n\r\n@media (max-width: 520px) {\r\n\r\n  .tabs {\r\n    flex-direction: column;\r\n    gap: 10px;\r\n  }\r\n\r\n  .tabButton {\r\n    width: 100%;\r\n    justify-content: flex-start; /* ⬅️ կարևորը */\r\n    padding: 14px 16px;\r\n    text-align: left;\r\n  }\r\n\r\n  /* icon fixed column */\r\n  .icon {\r\n    width: 26px;\r\n    height: 26px;\r\n    min-width: 26px; /* ⬅️ բոլոր icon-ները նույն սյունակում */\r\n    margin-right: 12px;\r\n  }\r\n\r\n  /* text column */\r\n  .tabButton span {\r\n    flex: 1;\r\n  }\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"servicePage": `servicePage_servicePage__GFO+X`,
	"container": `servicePage_container__VYOD-`,
	"pageTitle": `servicePage_pageTitle__9QFqR`,
	"tabs": `servicePage_tabs__bTvQ0`,
	"tabButton": `servicePage_tabButton__6iEZp`,
	"activeTab": `servicePage_activeTab__vUMIb`,
	"icon": `servicePage_icon__e0BJt`,
	"layout": `servicePage_layout__wnW1T`,
	"content": `servicePage_content__HYlFo`,
	"section": `servicePage_section__ya20K`,
	"sectionTitle": `servicePage_sectionTitle__af2Eq`,
	"paragraph": `servicePage_paragraph__fitsd`,
	"list": `servicePage_list__sz5od`,
	"sidebar": `servicePage_sidebar__9tHJO`,
	"sidebarToggle": `servicePage_sidebarToggle__LYNfh`,
	"sidebarInner": `servicePage_sidebarInner__U1+fy`,
	"menuItem": `servicePage_menuItem__xyK0c`,
	"menuItemActive": `servicePage_menuItemActive__A9QW2`,
	"sidebarOpen": `servicePage_sidebarOpen__2XNx8`
};
export default ___CSS_LOADER_EXPORT___;
